
export const WmsTaskStatus = {
    IDLE: 'idle',
    IN_PROGRESS: 'in_progress',
    COMPLETED: 'completed',
    CANCELED: 'canceled',
}

export function getWmsTaskStatus() {
    return [
        WmsTaskStatus.IDLE,
        WmsTaskStatus.IN_PROGRESS,
        WmsTaskStatus.COMPLETED,
        WmsTaskStatus.CANCELED
    ]
}